import universal from 'react-universal-component';


export default universal(() => import('./Print'));


// WEBPACK FOOTER //
// ./src/app/views/Print/index.js